<template>
  <div class="referral-history">
    <v-row no-gutters>
      <v-col cols="12">
        <v-row no-gutters>
          <v-col class="pa-0" :class="$vuetify.breakpoint.mdAndUp ? '' : 'px-2'" @click="goToReferralPage()">
            <img loading="lazy" v-if="$vuetify.breakpoint.smAndDown" src="/static/svg/arrowLeft.svg" width="15" height="15" />
            <span class="header-font-size-bigger yellow-theme-color">{{ $t(`label.referralHistory`) }}</span>
          </v-col>
        </v-row>
        <v-row no-gutters class="d-flex justify-start " style="gap: 15px; padding: 12px !important;">
          <v-col cols="12" class="pb-3 pa-0 scrollable-row">
            <v-btn
              style="width: 200px;"
              class="white--text dialog-button subtitle-1 full-width text-capitalize pa-2 defaultTabView"
              @click="redirectDownLineReport()"
              :class="this.currentRouteName === this.routeName.REFERRAL_DOWNLINE_REPORT ? 'selectedTabView' : ''"
            >
              {{ $t(`label.downlineReport`) }}
            </v-btn>
            <v-btn
              style="width: 200px;"
              class="white--text dialog-button subtitle-1 full-width text-capitalize pa-2 defaultTabView"
              :class="this.currentRouteName === this.routeName.REFERRAL_REPORT ? 'selectedTabView' : ''"
              @click="redirectReferralReport()"
            >
              {{ $t(`button.referralReport`) }}
            </v-btn>
            <v-btn
              style="width: 200px;"
              :class="this.currentRouteName === this.routeName.REFERRAL_HISTORY ? 'selectedTabView' : ''"
              class="white--text dialog-button subtitle-1 full-width text-capitalize pa-2 defaultTabView"
              @click="redirectToReferralHistory()"
            >
              {{ $t(`button.redeemHistory`) }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-data-table light :headers="headers" :items="filteredReports" class="elevation-0" :hide-default-footer="true" hide-default-header :items-per-page="-1">
          <template v-slot:header="{ props }">
            <tr>
              <th class="referral-table-header white--text text-start" style="padding: 10px 16px" v-for="head in props.headers" :key="head.text">
                <span v-if="head.text !== 'dateSearch'">
                  {{ $t(`label.${head.text}`) }}
                  <span v-if="head.sortable">
                    <v-icon v-if="head.sortBy == 'asc'">arrow_drop_down</v-icon>
                    <v-icon v-if="head.sortBy == 'desc'">arrow_drop_up</v-icon>
                  </span>
                </span>
              </th>
              <th class="referral-table-header text-end" style="border-bottom: thin solid rgba(0,0,0,.12);padding: 10px 16px">
                <v-menu ref="menu" v-model="dateOfBirthMenu" :close-on-content-click="false" offset-y transition="scale-transition" max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateRangeText"
                      clearable
                      @click:clear="clearFilter()"
                      outlined
                      class="date-search ml-3 elevation-0"
                      hide-details="true"
                      v-on="on"
                      append-icon="search"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="filterListByDate()" color="white" no-title v-model="dates" @input="selectedDate()" range></v-date-picker>
                </v-menu>
              </th>
            </tr>
          </template>
          <template v-slot:body="{ items }">
            <tr v-for="(item, index) in items" :key="index" :class="getRowClass(index)">
              <td class="text-start white--text" style="border-bottom: thin solid rgba(0,0,0,.12);padding: 10px 16px">
                {{ item.updated_at | longDate }}
              </td>
              <td class="text-start white--text" style="border-bottom: thin solid rgba(0,0,0,.12);padding: 10px 16px">
                {{ item.downline_membercode }}
              </td>
              <td class="text-start white--text" style="border-bottom: thin solid rgba(0,0,0,.12);padding: 10px 16px">
                {{ item.commission_amount | currency(currentCurrency) }}
              </td>
              <td class="text-start white--text text-capitalize" style="border-bottom: thin solid rgba(0,0,0,.12);padding: 10px 16px">
                <v-icon color="red" class="mb-1" small v-if="item.status == 'failed'">cancel</v-icon>
                <v-icon color="green" class="mb-1" small v-if="item.status == 'success'">check_circle</v-icon>
                <v-icon color="yellow" class="mb-1" small v-if="item.status == 'pending'">watch_later</v-icon>
                {{ item.status }}
              </td>
              <td class="text-start white--text" style="border-bottom: thin solid rgba(0,0,0,.12);padding: 10px 16px"></td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row no-gutters v-if="false">
      <v-col cols="12">
        <v-menu ref="menu" v-model="dateOfBirthMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateRangeText"
              clearable
              @click:clear="clearFilter()"
              color="buttonPrimary"
              outlined
              class="date-search-mobile mb-3 elevation-0"
              hide-details="true"
              v-on="on"
              append-icon="search"
            ></v-text-field>
          </template>
          <v-date-picker color="buttonPrimary" @change="filterListByDate()" no-title v-model="dates" range></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12">
        <v-row v-for="(item, index) in filteredReports" :key="index">
          <v-col cols="2">
            <v-icon color="red" class="mt-2" v-if="item.status == 'failed'">cancel</v-icon>
            <v-icon color="green" class="mt-2" v-if="item.status == 'success'">check_circle</v-icon>
            <v-icon color="yellow" class="mt-2" v-if="item.status == 'pending'">watch_later</v-icon>
          </v-col>
          <v-col cols="4">
            <v-row no-gutters class="referral-table-header">
              <v-col cols="12">
                {{ $t(`label.date`) }}
              </v-col>
              <v-col cols="12">
                {{ $t(`label.commission`) }}
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row no-gutters>
              <v-col cols="12">
                {{ item.created_at | longDate }}
              </v-col>
              <v-col cols="12">
                {{ item.commission_amount | currency(currentCurrency) }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="filteredReports.length == 0" class="text-center pt-0 pb-8">
        <label class="referral-table-header subtitle-2">{{ $t(`message.noDataAvaliable`) }}</label>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { uiHelper, formValidator } from '@/util'
import { SHARED } from '@/constants/constants'
import deleteIcon from '@/assets/svg/delete-icon.svg'
import cloneDeep from 'lodash/cloneDeep'
import { REFERRAL_GET_REPORT } from '@/store/referral.module'
import { ROUTE_NAME } from '@/constants/route.constants'
export default {
  name: 'referralHistory',
  components: {
    deleteIcon
  },
  data: () => ({
    routeName: ROUTE_NAME,
    dateOfBirthMenu: false,
    currentCurrency: uiHelper.getCurrency(),
    language: uiHelper.getLanguage(),
    validator: formValidator,
    shared: SHARED,
    selectedTab: 'tier',
    dates: ['', ''],
    headers: [
      {
        text: 'date',
        align: 'start',
        sortable: false,
        value: 'member_id'
      },
      {
        text: 'memberCode',
        value: 'membercode',
        sortable: false
      },
      {
        text: 'commission',
        value: 'commission',
        sortable: false
      },
      {
        text: 'status',
        value: 'status',
        sortable: false
      }
    ],
    reports: [],
    filteredReports: []
  }),
  created() {
    this.metaTag()
    this.getReferralReports()
  },
  computed: {
    currentRouteName() {
      return this.$route.name
    },
    getRowClass() {
      return index => {
        return index % 2 === 0 ? 'even-row' : 'odd-row'
      }
    },
    dateRangeText: {
      get() {
        let startDate = this.dates[0] ? this.dates[0] : ''
        let endDate = this.dates[1] ? this.dates[1] : ''
        return startDate + ' - ' + endDate
      },
      set(dateRange) {
        this.dates = []
      }
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    referralReports() {
      return this.$store.state.referral.reports
    }
  },
  watch: {
    referralReports() {
      this.reports = this.$store.state.referral.reports
      this.filterListByDate()
    }
  },
  methods: {
    goToReferralPage() {
      this.$router.push({
        name: ROUTE_NAME.REFERRAL_SUMMARY,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    redirectToReferralHistory() {
      this.$router.push({
        name: ROUTE_NAME.REFERRAL_HISTORY,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    redirectDownLineReport(selectedTAB) {
      this.$router.push({
        name: ROUTE_NAME.REFERRAL_DOWNLINE_REPORT,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    redirectReferralReport() {
      this.$router.push({
        name: ROUTE_NAME.REFERRAL_REPORT,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    metaTag() {
      const currentUrl = window.location.href
      uiHelper.setCanonical(currentUrl)
      const domainWithProtocol = currentUrl.split('/')[2]
      const domain = domainWithProtocol.replace(/(^\w+:|^)\/\//, '')
      const path = window.location.pathname
      const cleanPath = path.replace(/\/(en-BD|bn-BD)/i, '')
      const Links = `https://${domain}${cleanPath}`
      const Linksen = `https://${domain}/en-BD${cleanPath}`
      const Linksbn = `https://${domain}/bn-BD${cleanPath}`
      uiHelper.setHreflangLinks(Links)
      uiHelper.setHreflangLinksen(Linksen)
      uiHelper.setHreflangLinksbd(Linksbn)
    },
    selectedDate() {
      if (this.dates[0] && this.dates[1]) {
        setTimeout(function() {
          this.dateOfBirthMenu = false
        }, 500)
      }
    },
    openMsgDialog(selectedMsg) {
      this.msgDialog = {
        show: true,
        msg: selectedMsg.message,
        title: selectedMsg.subject
      }
    },
    closeMsgDialog() {
      this.msgDialog = {
        show: false
      }
    },
    getReferralReports() {
      if (this.isLoggedIn) this.$store.dispatch(`${REFERRAL_GET_REPORT}`)
    },
    filterListByDate() {
      if (this.dates[0] && this.dates[1]) {
        var startDate = new Date(this.dates[0])
        var endDate = new Date(this.dates[1])
        endDate.setHours(23, 59, 59, 999)
        this.filteredReports = this.reports.filter(function(r) {
          let date = new Date(r.created_at)
          return date >= startDate && date <= endDate
        })
      } else {
        return (this.filteredReports = cloneDeep(this.reports))
      }
    },
    clearFilter() {
      this.dates = []
      this.filterListByDate()
    }
  }
}
</script>

<style lang="scss">
.scrollable-row {
  display: flex;
  flex-wrap: nowrap !important; /* Prevent wrapping */
  overflow-x: auto; /* Enables horizontal scrolling */
  -ms-overflow-style: none; /* Hide IE scrollbar */
  padding-bottom: 10px;
}

.scrollable-row::-webkit-scrollbar {
  height: 8px; /* Adjust height for horizontal scrollbar */
}

.scrollable-row::-webkit-scrollbar-thumb {
  background-color: #ffc000 !important;
  border-radius: 10px !important;
}

.scrollable-row::-webkit-scrollbar-track {
  background: #3d3360; /* Track color */
  border-radius: 10px;
}
.date-search .v-input__icon--clear .v-icon {
  color: #fff !important;
}
.date-search .v-input__append-inner .v-input__icon--append .v-icon {
  color: #fff !important;
}
.header-font-size {
  font-size: 18px;
}
.header-font-size-bigger {
  font-size: 21px;
}
.yellow-theme-color {
  color: #ffc000;
}
.theme-color {
  color: #322c44 !important;
}
.defaultTabView {
  background-color: transparent !important;
  border-radius: 23px;
}
.selectedTabView {
  background: transparent linear-gradient(180deg, #ff5ae4 0%, #fd57e3 41%, #c817c2 100%) !important;
  border-radius: 23px;
  opacity: 1;
}
.even-row {
  background-color: #3d3360;
}
.even-row2 {
  background-color: #3d3360;
  margin-left: -16px;
  margin-right: -16px;
}
.odd-row {
  background-color: #322c44;
}
.odd-row2 {
  background-color: #322c44;
}
.referral-history {
  .date-search {
    width: fit-content;
    margin-right: 0px;
    float: right !important;
    .v-input__slot {
      min-height: 40px !important;
      max-width: 250px;
    }
    .v-input__append-inner {
      margin-top: 8px;
    }
  }
  .referral-table-header {
    background: #322c44;
    border: thin solid #413275;
    padding: 10px 16px;
  }
}

.date-search-mobile {
  .v-input__slot {
    min-height: 40px !important;
  }
  .v-input__append-inner {
    margin-top: 8px;
  }
}
</style>
